import { ReturnsAndClaimsPermissions } from "@redotech/account-common/permissions";
import * as z from "zod";
import { canFlagReturn } from "../../returns/return-action-eligibility";
import { defineReturnAction } from "../types";

/** No note: see TODO(RET1-2855) in the flag handler. */
const BulkFlagPayloadSchema_ = z.object({});
export interface FlagPayload extends z.infer<typeof BulkFlagPayloadSchema_> {}

export const flagReturnAction = defineReturnAction<FlagPayload>({
  label: "Flag",
  permissions: [ReturnsAndClaimsPermissions.FLAG_RETURN],
  isEligible: ({ return_ }) => canFlagReturn({ return_ }),
  payloadSchema: BulkFlagPayloadSchema_,
  examplePayload: {},
});
